import React from 'react';
import './CompetitionCriteriasWidget.scss';

const SVGHelper = {
    title: (value) => {
        const titleProps = {
            display: 'inline-block',
            height: '75',
            style: {
                fill: '#FFFFFF',
                fontSize: '60px',
                fontWeight: 700,
                verticalAlign: 'middle',
                paddingLeft: '10px',
                width: '110px'
            },
        };

        return (
            <svg {...titleProps}>
                <text y={45}>{value}</text>
            </svg>
        );
    }
}

const CompetitionCriteriasWidget = (props) => {
    const { slide, companyProfile } = props;
    const customTextColor = slide ? slide.custom.bgColor : companyProfile.colors.mainBg;

    let criterias = slide.competitionSettings.criterias;

    let adjustFontSize = "30px";
    if (criterias.length > 5) {
        adjustFontSize = "22px"
    }

    criterias = _.map(criterias, (criteria, i) => {

        return (
            <div className='criteria-container' key={i}>
                <div>{SVGHelper.title(criteria.points + "p")}</div>
                <div style={{ fontSize: adjustFontSize, color: '#FFFFFF' }}>{criteria.status} {criteria.type}</div>
            </div>
        );

    });

    return (
        <div className="CompetitionCriteriasWidget" style={{
            display: 'flex', alignItems: 'center', justifyContent: "center", background: customTextColor
        }}>
            {criterias}
        </div >
    );
};

CompetitionCriteriasWidget.propTypes = {
    widget: React.PropTypes.object,
};

export default CompetitionCriteriasWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/CompetitionWidgets/CompetitionCriteriasWidget.jsx
 **/